<section class="section-product-hero">
  <div class="section-container">
    <div class="product-hero-content-box">
      <div>
        <span class="product-hero-subheading mar-b-16">{{
          newBusinessHeroHeader?.tags[0]?.fields?.tagText
        }}</span>
        <h1 class="product-hero-header" [innerHTML]="highlightedText"></h1>
        <p class="landing-hero-content mar-t-24">
          {{ newBusinessHeroHeader?.content?.content[0]?.content[0].value }}
        </p>
        <div class="landing-btn mar-t-48 align-c">
          <a
            href="{{ newBusinessHeroHeader?.buttons[0]?.fields?.redirectLink | urlParams:queryParams}}"
            target="{{ newBusinessHeroHeader?.buttons[0]?.fields?.actionType }}"
            class="btn btn-full"
          >
            {{ newBusinessHeroHeader?.buttons[0]?.fields?.buttonText }}
          </a>
          <app-common-talktosales-button
            [text]="newBusinessHeroHeader?.buttons[1]?.fields?.buttonText"
          ></app-common-talktosales-button>
        </div>
      </div>
      <img
        loading="lazy"
        class="product-hero-img"
        [src]="newBusinessHeroHeader?.image[0]?.fields?.file?.url"
        alt="Transform Your Business with a Global Multi-Currency Account"
      />
    </div>
  </div>
</section>
